import { createBrowserRouter } from "react-router-dom";

import { DashboardLayout } from "@/app/layouts/DashboardLayout";
import { NotFoundPage } from "@/app/router/NotFoundPage";
import { RouteErrorBoundary } from "@/app/router/RouteErrorBoundary";
import { AuthGuard, PermissionGuard } from "@/app/router/guards";
import { AdminUsersPage } from "@/features/admin-users/presentation/pages/AdminUsersPage";
import { AdviceCategoriesPage } from "@/features/advice/presentation/pages/AdviceCategoriesPage";
import { AdvicePage } from "@/features/advice/presentation/pages/AdvicePage";
import { AuditLogsPage } from "@/features/audit-logs/presentation/pages/AuditLogsPage";
import { LoginPage } from "@/features/auth/presentation/pages/LoginPage";
import { MfaPage } from "@/features/auth/presentation/pages/MfaPage";
import { ProfilePage } from "@/features/auth/presentation/pages/ProfilePage";
import { SessionExpiredPage } from "@/features/auth/presentation/pages/SessionExpiredPage";
import { CircleGroupDetailPage } from "@/features/circle/presentation/pages/CircleGroupDetailPage";
import { CircleGroupsPage } from "@/features/circle/presentation/pages/CircleGroupsPage";
import { DashboardPage } from "@/features/dashboard/presentation/pages/DashboardPage";
import { PopupsPage } from "@/features/popups/presentation/pages/PopupsPage";
import { Permission } from "@/store/apis/adminApi.types";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage />, errorElement: <RouteErrorBoundary /> },
  { path: "/mfa", element: <MfaPage />, errorElement: <RouteErrorBoundary /> },
  {
    path: "/sesion-expirada",
    element: <SessionExpiredPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <DashboardPage /> },
      {
        path: "consejos",
        element: (
          <PermissionGuard allow={[Permission.AdviceRead]} fallback={<NotFoundPage />}>
            <AdvicePage />
          </PermissionGuard>
        ),
      },
      {
        path: "consejos/categorias",
        element: (
          <PermissionGuard allow={[Permission.AdviceRead]} fallback={<NotFoundPage />}>
            <AdviceCategoriesPage />
          </PermissionGuard>
        ),
      },
      {
        path: "popups",
        element: (
          <PermissionGuard allow={[Permission.PopupsRead]} fallback={<NotFoundPage />}>
            <PopupsPage />
          </PermissionGuard>
        ),
      },
      {
        path: "circulo/grupos",
        element: (
          <PermissionGuard allow={[Permission.CircleRead]} fallback={<NotFoundPage />}>
            <CircleGroupsPage />
          </PermissionGuard>
        ),
      },
      {
        path: "circulo/grupos/:id",
        element: (
          <PermissionGuard allow={[Permission.CircleRead]} fallback={<NotFoundPage />}>
            <CircleGroupDetailPage />
          </PermissionGuard>
        ),
      },
      {
        path: "admins",
        element: (
          <PermissionGuard allow={[Permission.AdminsManage]} fallback={<NotFoundPage />}>
            <AdminUsersPage />
          </PermissionGuard>
        ),
      },
      {
        path: "auditoria",
        element: (
          <PermissionGuard allow={[Permission.AuditRead]} fallback={<NotFoundPage />}>
            <AuditLogsPage />
          </PermissionGuard>
        ),
      },
      { path: "perfil", element: <ProfilePage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
